import { UUID } from './util';
import {
  CONTAINER,
  ROW,
  COLUMN,
  ELEMENT
} from './element-categories';

export function validateColumnsWidth(columns) {
  let columnsNo = columns.length,
      result = [],
      columnsWithoutWidthNo = 0,
      widthSum = 0;

  for (let i = 0; i < columnsNo; i++) {
    let column = columns[i] || {},
        width = column.width;

    if (typeof width === 'number') {
      widthSum += Math.floor(width);
    } else {
      columnsWithoutWidthNo++;
    }
  }

  if (columnsWithoutWidthNo > 0) {
    let reminingWidth = 12 - widthSum,
        width = Math.floor(reminingWidth / columnsWithoutWidthNo),
        rem = reminingWidth % columnsWithoutWidthNo;

    for (let i = 0; i < columnsNo; i++) {
      let column = columns[i] || {},
          columnWidth = column.width,
          w;

      if (typeof columnWidth === 'number') {
        w = Math.floor(columnWidth);
      } else {
        w = width + (rem-- > 0 ? 1 : 0);
      }

      result.push(validateColumn({ ...column, width: w }));
    }
  } else {
    let reminingWidth = 12 - widthSum,
        width = Math.floor(reminingWidth / columnsNo),
        rem = reminingWidth % columnsNo;

    for (let i = 0; i < columnsNo; i++) {
      let column = columns[i],
          columnWidth = column.width,
          w = Math.floor(columnWidth) + width + (rem-- > 0 ? 1 : 0);

      result.push(validateColumn({ ...column, width: w }));
    }
  }

  return result;
}

export function validateElement(element) {
  element = element || {};
  let id = element.id !== undefined ? element.id : UUID();

  if (typeof element.type !== 'string') {
    throw Error('Element must have a type property.');
  }

  return {
    ...element,
    id,
    category: ELEMENT
  };
}

export function validateElements(elements) {
  elements = elements || [];
  return elements.map(validateElement);
}

export function validateColumn(column) {
  column = column || {};
  let id = column.id !== undefined ? column.id : UUID();

  return {
    ...column,
    id,
    category: COLUMN,
    elements: validateElements(column.elements)
  };
}

export function validateColumns(columns) {
  columns = columns || [];

  let result = columns.map(validateColumn);

  if (result.length > 12) {
    result.length = 12;
  }

  if (result.length === 0) {
    result.push(validateColumn());
  }

  result = validateColumnsWidth(result);

  return result;
}

export function validateRow(row) {
  row = row || {};
  let id = row.id !== undefined ? row.id : UUID();

  return {
    ...row,
    category: ROW,
    id,
    columns: validateColumns(row.columns)
  };
}

export function validateRows(rows) {
  rows = rows || [];

  let result = rows.map(validateRow);

  if (result.length === 0) {
    result.push(validateRow());
  }

  return result;
}

export function validateContainer(container) {
  const { id = UUID(), highlightedId = id } = container;

  return {
    ...container,
    id,
    highlightedId,
    category: CONTAINER,
    rows: validateRows(container.rows)
  };
}

export function validateUndoableContainer(container) {
  const { past, present, future } = container;

  return {
    ...container,
    past: past.map(validateContainer),
    future: future.map(validateContainer),
    present: validateContainer(present)
  };
}

export function validateModel(model) {
  model = model || {};

  return {
    ...model,
    activeDevice: validateActiveDevice(model.activeDevice),
    desktop: validateUndoableContainer(model.desktop),
    tablet: validateUndoableContainer(model.tablet),
    mobile: validateUndoableContainer(model.mobile)
  };
}

export function validateToolbox(toolbox) {
  return toolbox || {};
}

export function validateActiveDevice(activeDevice) {
  return activeDevice || 'desktop';
}

export function validateViewModel(viewModel) {
  viewModel = viewModel || {};

  return {
    ...viewModel,
    toolbox: validateToolbox(viewModel.toolbox)
  };
}

export function validateState(state) {
  state = state || {};

  return {
    ...state,
    model: validateModel(state.model),
    viewModel: validateViewModel(state.viewModel)
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/state-validator.js